import './appointment-route.component.js';
import './appointment-route.controller.js';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('inkfinder.appointments.details', {
    url: '/{appointment_id:[0-9]{1,100}}?open',
    views: {
      '@': {
        component: 'inkAppointmentRoute'
      }
    },
    resolve: {
      $title: (() => 'Your appointment'),
      project: function(Appointment, Project, $stateParams, _) {
        return Appointment.get($stateParams.appointment_id)
        .then(function(appointment) {
          return Project.get(appointment.project)
          .then(function(project) {
            return project;
          });
        });
      },
      appointments: function(project, Appointments) {
        let search = false;
        let start;
        let end;
        let timestamp;
        let artist;
        let collector;
        const projectId = project.id;
        return Appointments
        .get(search, start, end, timestamp, artist, collector, projectId)
        .then(function(appointments) {
          return appointments;
        });
      },
      currentAppointment: function(appointments, _, $stateParams) {
        return _.find(appointments, function(appointment) {
          if (appointment.id === Number($stateParams.appointment_id)) {
            return true;
          }
        });
      },
      open: function($stateParams) {
        return $stateParams.open;
      }
    },
    params: {
      appointment_id: {dynamic: true}
    }
  });
});



// WEBPACK FOOTER //
// ./routes/appointment/index.js